(() => {
  const initialize = (root = document) => {
    const sections = root.matches?.('.m-pdp') ? [root] : root.querySelectorAll?.('.m-pdp') || [];

    sections.forEach((section) => {
      const tabs = section.querySelector('[data-product-tabs]');
      if (tabs && !tabs.dataset.ready) {
        tabs.dataset.ready = 'true';
        const buttons = Array.from(tabs.querySelectorAll('[data-product-tab]'));
        const panels = Array.from(tabs.querySelectorAll('[data-product-panel]'));
        const activate = (button, focus = false) => {
          buttons.forEach((item) => {
            const active = item === button;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.productPanel !== button.dataset.productTab; });
          if (focus) button.focus();
        };

        buttons.forEach((button, index) => {
          button.addEventListener('click', () => activate(button));
          button.addEventListener('keydown', (event) => {
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
            else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = buttons.length - 1;
            else return;
            event.preventDefault();
            activate(buttons[nextIndex], true);
          });
        });
      }

      const form = section.querySelector('.m-pdp__form');
      if (form && !form.dataset.quantityReady) {
        form.dataset.quantityReady = 'true';
        const quantity = form.querySelector('[data-direct-buy-quantity]');
        form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
          if (!quantity) return;
          quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) - 1));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
        form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
          if (!quantity) return;
          quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) + 1));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
        form.querySelector('[data-direct-buy-variant]')?.addEventListener('change', (event) => {
          const option = event.target.selectedOptions?.[0];
          const price = section.querySelector('[data-variant-price]');
          const image = section.querySelector('[data-pdp-main]');
          if (option?.dataset.price && price) price.textContent = option.dataset.price;
          const compare = section.querySelector('[data-variant-compare]');
          if (compare) { compare.textContent = option?.dataset.comparePrice || ''; compare.hidden = !option?.dataset.comparePrice; }
          const stock = section.querySelector('[data-stock-message]');
          if (stock) { stock.hidden = option?.dataset.available === 'false'; const copy = stock.querySelector('[data-stock-copy]'); if(copy && option?.dataset.stock) copy.textContent = option.dataset.stock; }
          if (option?.dataset.image && image) {
            image.src = option.dataset.image;
            image.removeAttribute('srcset');
          }
        });
      }
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
